/* eslint-disable */
import React from "react"
import { NavLink, useLocation } from "react-router-dom"
// chakra imports
import { Box, Button, Flex, HStack, Icon, Link, Text, useColorModeValue } from "@chakra-ui/react"
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks"
import { UNLOCK_ROUTE, ADMIN_ROUTE } from "routes"
import { GoZap } from "react-icons/go"

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation()
  let activeColor = useColorModeValue("gray.700", "white")
  let inactiveColor = useColorModeValue("secondaryGray.600", "secondaryGray.600")
  let activeIcon = useColorModeValue("brand.500", "white")
  let textColor = useColorModeValue("secondaryGray.500", "white")
  let brandColor = useColorModeValue("brand.500", "brand.400")

  const { address } = useGetAccountInfo()

  let isAdmin = false
  //Change Admin Status for theses wallet
  const ADMINS = [
    "erd1qh2m98dfkwyn4alps085a84x6pw04gar54fzna7c7frj7x9hpu3sd205vr",
    "erd1hupwkm6ls5kldvhzd02yhxy995gxtmv7px5l3t5l8jtu28jfqtlq040k9n",
    "erd1enl9te4t7tkp90f52tz4zel8687yw3t7vnranrku0jchtyytvvmqqv98xu",
    "erd1rg0x908m3w7yyucr2em8429umapnvdt06avuvdqtnf7vv6saqxqsapfjj5"
  ]

  if (ADMINS.includes(address)) {
    isAdmin = true
  }

  const isLoggedIn = Boolean(address)

  const { routes } = props

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName)
  }

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        (isLoggedIn && route.path === UNLOCK_ROUTE.path) ||
        (!isLoggedIn && route.authenticatedRoute) ||
        (route.isAdmin && !isAdmin)
      ) {
        return null
      }
      if (route.path === UNLOCK_ROUTE.path) {
        return (
          <Button
            key={index}
            ml={"auto"}
            mr="auto"
            mt={"auto"}
            mb="30px"
            className="btn-secondary"
            cursor="pointer"
          >
            <NavLink to={route.path}>
              <HStack py="5px" ps="10px">
                <Icon as={GoZap} width="16px" height="16px" color="inherit" />
                <Flex w="100%" m={"0"} alignItems="flex-start" justifyContent="center">
                  <Box color={textColor} me="18px"></Box>
                  <Text me="auto" color={textColor} fontWeight={"normal"}>
                    Connect
                  </Text>
                </Flex>
                <Box h="36px" w="4px" bg={"transparent"} borderRadius="5px" />
              </HStack>
            </NavLink>
          </Button>
        )
      }
      return (
        <NavLink key={index} to={route.path}>
          <Box>
            <HStack
              spacing={activeRoute(route.path.toLowerCase()) ? "22px" : "26px"}
              py="5px"
              ps="10px"
            >
              <Flex w="100%" alignItems="center" justifyContent="center">
                <Box
                  color={activeRoute(route.path.toLowerCase()) ? activeIcon : textColor}
                  me="18px"
                >
                  {route.icon}
                </Box>
                <Text
                  me="auto"
                  color={activeRoute(route.path.toLowerCase()) ? activeColor : textColor}
                  fontWeight={activeRoute(route.path.toLowerCase()) ? "bold" : "normal"}
                >
                  {route.name}
                </Text>
              </Flex>
              <Box
                h="36px"
                w="4px"
                bg={activeRoute(route.path.toLowerCase()) ? brandColor : "transparent"}
                borderRadius="5px"
              />
            </HStack>
          </Box>
        </NavLink>
      )
    })
  }
  //  BRAND
  return createLinks(routes)
}

export default SidebarLinks
